import { Component, input, output, model, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { BrandService } from '../../services/brand.service';
import Swal from 'sweetalert2';
import { FormMode } from 'app/core/constants/form-mode';
import { PermissionService } from '@services/core/permission.service';

@Component({
    selector: 'app-brand-form',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './brand-form.component.html'
})
export class BrandFormComponent {

    brandForm = input.required<FormGroup>();
    formChange = output<FormGroup | null>();
    mode = model<FormMode>(FormMode.CREATE);
    formMode = FormMode;

    private brandService = inject(BrandService);
    readonly perm = inject(PermissionService);

    public Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true
    });

    submit() {
        if (this.brandForm() && this.brandForm().valid) {
            this.formChange.emit(this.brandForm());
        }
    }

    editMode() {
        this.mode.set(this.formMode.EDIT);
    }

    deleteBrand() {
        if (!this.perm.canCurrent('canDelete')) return;
        const id = this.brandForm().get('id')?.value ?? this.brandForm().get('code')?.value;
        if (!id) {
            this.Toast.fire({ icon: 'error', title: 'No se puede eliminar sin un código válido' });
            return;
        }

        Swal.fire({
            title: '¿Eliminar marca?',
            text: 'Solo se puede eliminar si ningún vehículo de un socio usa esta marca. También se borrarán sus modelos sin uso.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (!result.isConfirmed) return;
            this.brandService.delete(id).subscribe({
                next: () => {
                    this.Toast.fire({ icon: 'success', title: 'La marca ha sido eliminada' });
                    this.formChange.emit(null);
                },
                error: (err) => this.Toast.fire({
                    icon: 'error',
                    title: err?.error?.error || err?.error?.message || 'No se pudo eliminar la marca'
                })
            });
        });
    }
}
